import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as yup from 'yup';
import AutoComplete from '../../../../components/formComponents/autoComplete';
import Input from "../../../../components/formComponents/formInput";
import GroupButton from "../../../../components/formComponents/groupButton";
import ModalNoti from "../../../../components/modalNoti";
import ModalTemplate from "../../../../components/modalTemplate";
import { autoCompleteDepartment, autoCompleteUser } from '../../../manageUser/service';
import { addProject, editProject } from '../../redux/action';
import ToastTopHelper from '../../../../utils/toast';

function FormStorage({show, onHide, isEdit, project}) {
  const [reason, setReason] = useState('');

  const dispatch = useDispatch();

  const [isShowFailPopUp, setIsShowFailPopUp] = useState(false);

  const [
    isAddingProject,
    isAddedProjectSuccess,
    isAddedProjectFail,

    isEditingProject,
    isEditedProjectSuccess,
    isEditedProjectFail,
  ] = useSelector((state) => [
    state.manageStorage.isAddingProject,
    state.manageStorage.isAddedProjectSuccess,
    state.manageStorage.isAddedProjectFail,

    state.manageStorage.isEditingProject,
    state.manageStorage.isEditedProjectSuccess,
    state.manageStorage.isEditedProjectFail,
  ]);

  const storageValidationSchema = yup.object().shape({
    account_name: yup
      .string()
      .max(50, ({ max }) => `Tên project tốt đa ${max} ký tự.`)
      .required('Vui lòng nhập Tên project.'),
    capacity: yup
      .number().typeError('Dung lượng cấp phải là số.')
      .min(0, 'Dung lượng cấp phải là số dương.')
      .required('Vui lòng nhập Dung lượng cấp.'),
    max_file_size: yup
      .number()
      .typeError('Max file size phải là số.')
      .min(0, 'Max file size phải là số dương.')
      .test({
        name: 'max',
        exclusive: false,
        params: { },
        message: 'Max file size không được lớn hơn Dung lượng cấp.',
        test: function (value) {
            return value <= Number(this.parent.capacity) * 1024
        },
      })
      .required('Vui lòng nhập Max file size.'),
    description: yup
      .string()
      .max(200, ({ max }) => `Mô tả project tốt đa ${max} ký tự.`)
      .required('Vui lòng nhập Mô tả project.'),
    file_time: yup
      .number()
      .typeError('Thời gian lưu trữ phải là số.')
      .min(0, 'Thời gian lưu trữ phải là số dương.')
      .required('Vui lòng nhập Thời gian lưu trữ.'),
    domain: yup.string(),
    email_dep_head: yup
      .string()
      .email('Email trưởng bộ phận không đúng định dạng. Vui lòng kiểm tra lại.')
      .test('server', 'Email trưởng bộ phận không đúng định dạng. Vui lòng kiểm tra lại.', val => (val && val.toLowerCase().split('@').pop() === 'fpt.com.vn'|| val && val.toLowerCase().split('@').pop() === 'fpt.com'))
      .required('Vui lòng nhập email trưởng bộ phận.'),
    name_dep_head: yup.string().required('Vui lòng nhập Tên trưởng bộ phận.'),
    phone_dep_head: yup.string()
      .test('len', 'SDT phải có 5 hoặc 10 số.', val => (val === null || val === undefined || val.length === 5 || val.length === 10))
      .required('Vui lòng nhập SDT trưởng bộ phận.'),
    email_manager: yup
      .string()
      .email('Email người phụ trách không đúng định dạng. Vui lòng kiểm tra lại.')
      .test('server', 'Email người phụ trách không đúng định dạng. Vui lòng kiểm tra lại.', val => (val && val.toLowerCase().split('@').pop() === 'fpt.com.vn'|| val && val.toLowerCase().split('@').pop() === 'fpt.com'))
      .required('Vui lòng nhập email người phụ trách.'),
    name_manager: yup.string().required('Vui lòng nhập Tên người phụ trách.'),
    phone_manager: yup.string()
      .test('len', 'SDT phải có 5 hoặc 10 số.', val => (val === null || val === undefined || val.length === 5 || val.length === 10))
      .required('Vui lòng nhập SDT Người phụ trách.'),
    department: yup.string().required('Vui lòng nhập Bộ phận.'),
  });

  const capitalize = (input) => {  
    return input.toLowerCase().replace(/\s+/g,' ').trim().split(' ').map(s => s.charAt(0).toUpperCase() + s.substring(1)).join(' ');  
  } 

  const clearSpace = (input) => {
    return input.replace(/\s+/g,' ').trim()
  }

  const onCreateOrUpdate = (data) => {
    const today = new Date();
    const todayStr = ("0" + today.getDate()).slice(-2) + "/" + ("0" + (today.getMonth() + 1)).slice(-2) + "/" + today.getFullYear();
    if(isEdit) {
      dispatch(editProject({
        api_key: project.api_key,
        account_name: data.account_name.toUpperCase(),
        description: data.description,
        department: clearSpace(data.department.toUpperCase()),
        email: data.email_manager.toLowerCase(),
        phone: data.phone_manager,
        capacity: data.capacity,
        update_date: todayStr,
        manager: {
          email: data.email_manager.toLowerCase(),
          name: capitalize(data.name_manager),
          phone: data.phone_manager
        },
        dep_head: {
          email: data.email_dep_head.toLowerCase(),
          name: capitalize(data.name_dep_head),
          phone: data.phone_dep_head
        },
        max_file_size: data.max_file_size,
        domain: data.domain,
        file_time: data.file_time,
        reason: reason
      })); 
    } else {
      dispatch(addProject({
        account_name: data.account_name.toUpperCase(),
        description: data.description,
        department: clearSpace(data.department.toUpperCase()),
        email: data.email_manager.toLowerCase(),
        phone: data.phone_manager,
        capacity: data.capacity,
        update_date: todayStr,
        manager: {
          email: data.email_manager.toLowerCase(),
          name: capitalize(data.name_manager),
          phone: data.phone_manager
        },
        dep_head: {
          email: data.email_dep_head.toLowerCase(),
          name: capitalize(data.name_dep_head),
          phone: data.phone_dep_head
        },
        max_file_size: data.max_file_size,
        domain: data.domain,
        file_time: data.file_time,
      })); 
    }
  }

  const {
    values,
    errors,
    touched,
    isValid,
    handleChange,
    handleBlur,
    handleSubmit,
    handleReset,
    setFieldValue,
    setTouched,
  } = useFormik({
    validateOnMount: true,
    enableReinitialize: true,
    initialValues: {
      account_name: isEdit ? project.account_name : '',
      capacity: isEdit ? project.capacity : '',
      max_file_size: isEdit ? project.max_file_size : '',
      description: isEdit ? project.description : '',
      file_time: isEdit ? project.file_time : '',
      domain: isEdit ? project.domain : '',
      email_dep_head: isEdit ? project.dep_head.email : '',
      name_dep_head: isEdit ? project.dep_head.name : '',
      phone_dep_head: isEdit ? project.dep_head.phone : '',
      email_manager: isEdit ? project.manager.email : '',
      name_manager: isEdit ? project.manager.name : '',
      phone_manager: isEdit ? project.manager.phone : '',
      department: isEdit ? project.department : '',
    },
    validationSchema: storageValidationSchema,
    onSubmit: onCreateOrUpdate,
  });

  const displayError = () => {

    if(errors.account_name && touched.account_name) {
      return errors.account_name;
    }

    if(errors.capacity && touched.capacity) {
      return errors.capacity;
    }

    if(errors.max_file_size && touched.max_file_size) {
      return errors.max_file_size;
    }

    if(errors.description && touched.description) {
      return errors.description;
    }

    if(errors.file_time && touched.file_time) {
      return errors.file_time;
    }

    if(errors.email_dep_head && touched.email_dep_head) {
      return errors.email_dep_head;
    }

    if(errors.name_dep_head && touched.name_dep_head) {
      return errors.name_dep_head;
    }

    if(errors.phone_dep_head && touched.phone_dep_head) {
      return errors.phone_dep_head;
    }

    if(errors.email_manager && touched.email_manager) {
      return errors.email_manager;
    }

    if(errors.name_manager && touched.name_manager) {
      return errors.name_manager;
    }

    if(errors.phone_manager && touched.phone_manager) {
      return errors.phone_manager;
    }

    if(errors.department && touched.department) {
      return errors.department;
    }

    if(isEdit && reason === '') {
      return 'Vui lòng nhập Lý do.';
    }
  }
  // Show Modal When Add Storage False
  useEffect(() => {
    if(isAddedProjectFail || isEditedProjectFail){
      setIsShowFailPopUp(true);
    }
  },[isAddedProjectFail, isEditedProjectFail])

  useEffect(() => {
    if(isEdit) {
      if(isEditedProjectSuccess) {
        handleReset();
        setReason('');
        onHide();
      }
    } else {
      if(isAddedProjectSuccess) {
        handleReset();
        setReason('');
        onHide();
      }
    }
  },[isAddedProjectSuccess, isEditedProjectSuccess, isEdit]);

  /*Handle auto complete for email dep head*/
  const [dataCompleteHead, setDataCompleteHead] = useState([]);

  useEffect(() => {
    if(values.email_dep_head !== '') {
      autoCompleteUser(values.email_dep_head).then(({success, data}) => {
        setDataCompleteHead(data);
      })
    } else {
      setDataCompleteHead([]);
    }
  }, [values.email_dep_head]);

  const handleSelectEmailHeadAutoComplete = async (index) => {
    await setFieldValue('email_dep_head', dataCompleteHead[index].email);
    await setTouched({
      ...touched,
      email_dep_head: true,
    });
    await setFieldValue('name_dep_head', dataCompleteHead[index].fullName);
    await setTouched({
      ...touched,
      name_dep_head: true,
    });
    await setFieldValue('phone_dep_head', dataCompleteHead[index].sdt);
    await setTouched({
      ...touched,
      phone_dep_head: true,
    });
    setDataCompleteHead([]);
  }

  /*Handle auto complete for email manager*/
  const [dataCompleteManager, setDataCompleteManager] = useState([]);

  useEffect(() => {
    if(values.email_manager !== '') {
      autoCompleteUser(values.email_manager).then(({success, data}) => {
        setDataCompleteManager(data);
      })
    } else {
      setDataCompleteManager([]);
    }
  }, [values.email_manager]);

  const handleSelectEmailManagerAutoComplete = async (index) => {
    await setFieldValue('email_manager', dataCompleteManager[index].email);
    await setTouched({
      ...touched,
      email_manager: true,
    });
    await setFieldValue('name_manager', dataCompleteManager[index].fullName);
    await setTouched({
      ...touched,
      name_manager: true,
    });
    await setFieldValue('phone_manager', dataCompleteManager[index].sdt);
    await setTouched({
      ...touched,
      phone_manager: true,
    });
    setDataCompleteManager([]);
  }

  /*Handle auto complete for department*/
  const [dataCompleteDepartment, setDataCompleteDepartment] = useState([]);

  useEffect(() => {
    if(values.department !== '') {
      autoCompleteDepartment(values.department).then(({success, data}) => {
        if(data.department_list?.length > 10) {
          setDataCompleteDepartment(data.department_list?.slice(0, 10));
        } else {
          setDataCompleteDepartment(data.department_list);
        }
      })
    } else {
      setDataCompleteDepartment([]);
    }
  }, [values.department]);

  const handleSelectDepartmentAutoComplete = async (index) => {
    await setFieldValue('department', dataCompleteDepartment[index]);
    await setTouched({
      ...touched,
      department: true,
    });
    setDataCompleteDepartment([]);
  }


  // return a promise
  function copyToClipboard(textToCopy) {
    
    if (navigator.clipboard && window.isSecureContext) {
       
        return navigator.clipboard.writeText(textToCopy);
    } else {
        console.log(1);
        let textArea = document.createElement("textarea");
        textArea.value = textToCopy;
       
        textArea.style.position = "fixed";
        textArea.style.left = "-999999px";
        textArea.style.top = "-999999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        return new Promise((res, rej) => {
            // here the magic happens
            document.execCommand('copy') ? res() : rej();
            textArea.remove();
        });
    }
  }
  return(
    <>
      <ModalTemplate show={show} onHide={onHide} title={isEdit ? "Cập nhật Storage":"Thêm Storage"}>
        <fieldset>
          <legend>Thông tin dự án</legend>
          <div className="row">
            <Input 
              classInput='col-lg-4 col-md-12'
              label='Tên dự án'
              placeholder='Nhập tên Project'
              required={true}
              value={values.account_name}
              isError={errors.account_name && touched.account_name}
              onChange={(e) => {
                let temp = e.target.value.replace(/[`~!@#$%^&*()|+=?;:'",.<>\{\}\[\]\\\/ ]/gi, '');
                setFieldValue('account_name', temp);
              }}
              onBlur={handleBlur('account_name')}
            ></Input>
            <Input
              classInput='col-lg-4 col-md-12'
              label='Dung lượng cấp (Gb)'
              placeholder='Nhập dung lượng'
              required={true}
              value={values.capacity}
              isError={errors.capacity && touched.capacity}
              onChange={handleChange('capacity')}
              onBlur={handleBlur('capacity')}
            ></Input>
            <Input
              classInput='col-lg-4 col-md-12'
              label='Max file size (Mb)'
              placeholder='Nhập max file size'
              required={true}
              value={values.max_file_size}
              isError={errors.max_file_size && touched.max_file_size}
              onChange={handleChange('max_file_size')}
              onBlur={handleBlur('max_file_size')}
            ></Input>
          </div>
          <div className="row pt-5">
            <Input 
              classInput='col-lg-4 col-md-12'
              label='Mô tả dự án'
              placeholder='Nhập mô tả (Tối đa 200 kí tự)'
              required={true}
              value={values.description}
              isError={errors.description && touched.description}
              onChange={(e) => {
                if(e.target.value.replace(/\s/g, '') !== '') {
                  handleChange('description')(e)
                } else {
                  setFieldValue('description', '');
                }
              }}
              onBlur={handleBlur('description')}
            ></Input> 
            <Input 
              classInput='col-lg-4 col-md-12'
              label='Thời gian lưu trữ (Ngày)'
              placeholder='Nhập thời gian lưu trữ'
              required={true}
              value={values.file_time}
              isError={errors.file_time && touched.file_time}
              onChange={handleChange('file_time')}
              onBlur={handleBlur('file_time')}
            ></Input>
            <Input 
              classInput='col-lg-4 col-md-12'
              label='Domain'
              placeholder='Nhập domain'
              value={values.domain}
              isError={errors.domain && touched.domain}
              onChange={(e) => {
                if(e.target.value.replace(/\s/g, '') !== '') {
                  handleChange('domain')(e)
                } else {
                  setFieldValue('domain', '');
                }
              }}
              onBlur={handleBlur('domain')}
            ></Input>
          </div>
          {isEdit && 
          <div className="row pt-5" onClick={
            async () => {
              await copyToClipboard(project.api_key ? project.api_key : "");
              ToastTopHelper.success("Đã copy api key");
            }
          }>
            <Input 
              classInput='col-lg-4 col-md-12'
              label='API Key'
              placeholder=''
              required={false}
              value={project.api_key ? project.api_key : ""}
              disabled={true}
              isError={false}
              onChange={(e) => {}}
            ></Input>
          </div>}
          
        </fieldset>
        <fieldset>
          <legend>Thông tin liên hệ</legend>
          <div className="row">
            <AutoComplete 
              classInput='col-lg-4 col-md-12'
              label='Email trưởng bộ phận'
              placeholder='example@fpt.com'
              required={true}
              value={values.email_dep_head}
              isError={errors.email_dep_head && touched.email_dep_head}
              onChange={handleChange('email_dep_head')}
              onBlur={handleBlur('email_dep_head')}
              autoComplete={dataCompleteHead.length === 0 ? [] : dataCompleteHead.map((e) => e.email)}
              onClick={handleSelectEmailHeadAutoComplete}
            ></AutoComplete>
            <Input 
              classInput='col-lg-4 col-md-12'
              label='Tên trưởng bộ phận'
              placeholder='Nhập tên trưởng bộ phận'
              required={true}
              value={values.name_dep_head}
              isError={errors.name_dep_head && touched.name_dep_head}
              onChange={(e) => {
                if(e.target.value.replace(/\s/g, '') !== '') {
                  let temp = e.target.value.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '');
                  setFieldValue('name_dep_head', temp);
                } else {
                  setFieldValue('name_dep_head', '');
                }
              }}
              onBlur={handleBlur('name_dep_head')}
            ></Input>
            <Input 
              classInput='col-lg-4 col-md-12'
              label='SDT trưởng bộ phận'
              placeholder='Nhập SDT trưởng bộ phận'
              required={true}
              value={values.phone_dep_head}
              isError={errors.phone_dep_head && touched.phone_dep_head}
              onChange={(e) => {
                let temp = e.target.value.replace(/[^0-9]/g, '');
                if(temp.length <= 10) {
                  setFieldValue('phone_dep_head', temp);
                } else {
                  setFieldValue('phone_dep_head', temp.substring(0, 10));
                }        
              }}
              onBlur={handleBlur('phone_dep_head')}
            ></Input>
          </div>
          <div className="row pt-5">
            <AutoComplete 
              classInput='col-lg-4 col-md-12'
              label='Email người phụ trách'
              placeholder='example@fpt.com'
              required={true}
              value={values.email_manager}
              isError={errors.email_manager && touched.email_manager}
              onChange={handleChange('email_manager')}
              onBlur={handleBlur('email_manager')}
              autoComplete={dataCompleteManager.length === 0 ? [] : dataCompleteManager.map((e) => e.email)}
              onClick={handleSelectEmailManagerAutoComplete}
            ></AutoComplete>
            <Input 
              classInput='col-lg-4 col-md-12'
              label='Tên người phụ trách'
              placeholder='Nhập tên người phụ trách'
              required={true}
              value={values.name_manager}
              isError={errors.name_manager && touched.name_manager}
              onChange={(e) => {
                if(e.target.value.replace(/\s/g, '') !== '') {
                  let temp = e.target.value.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '');
                  setFieldValue('name_manager', temp);
                } else {
                  setFieldValue('name_manager', '');
                }
              }}
              onBlur={handleBlur('name_manager')}
            ></Input>
            <Input 
              classInput='col-lg-4 col-md-12'
              label='SDT người phụ trách'
              placeholder='Nhập SDT người phụ trách'
              required={true}
              value={values.phone_manager}
              isError={errors.phone_manager && touched.phone_manager}
              onChange={(e) => {
                let temp = e.target.value.replace(/[^0-9]/g, '');
                if(temp.length <= 10) {
                  setFieldValue('phone_manager', temp);
                } else {
                  setFieldValue('phone_manager', temp.substring(0, 10));
                }        
              }}
              onBlur={handleBlur('phone_manager')}
            ></Input>
          </div>
          <div className="row pt-5">
            <AutoComplete 
              classInput='col-lg-4 col-md-12'
              label='Bộ phận'
              placeholder='Nhập bộ phận'
              required={true}
              value={values.department}
              isError={errors.department && touched.department}
              onChange={(e) => {
                if(e.target.value.replace(/\s/g, '') !== '') {
                  let temp = e.target.value.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '');
                  setFieldValue('department', temp);
                } else {
                  setFieldValue('department', '');
                }
              }}
              onBlur={handleBlur('department')}
              autoComplete={dataCompleteDepartment}
              onClick={handleSelectDepartmentAutoComplete}
            ></AutoComplete>
          </div>
        </fieldset>
        {isEdit && 
          <Input 
            classInput='col-lg-12 col-md-12'
            label='Lý do thay đổi'
            placeholder='Nhập lý do thay đổi'
            required={true}
            value={reason}
            isError={reason === ''}
            onChange={(e) => {
              if(e.target.value.replace(/\s/g, '') !== '')  {
                setReason(e.target.value);
              } else {
                setReason('');
              }
            }}
          ></Input>
        }
        <div className="noti_report">
          {displayError()}
        </div>
        <GroupButton
          leftButton={{
            onClick: () => {
              onHide();
            },
            content: 'Đóng',
            disabled: false,
          }}
          rightButton={{
            onClick: () => {
              handleSubmit();
            },
            content: isEdit ? 'Cập nhật' : 'Thêm mới',
            disabled: isEdit ? (!isValid || isAddingProject || isEditingProject || reason === '') : (!isValid || isAddingProject || isEditingProject)
          }}
        ></GroupButton>
      </ModalTemplate>

      <ModalNoti
				show={isShowFailPopUp}
				onHide={() => setIsShowFailPopUp(false)}
				closeButton={false}
				content={"Xảy ra lỗi trong quá trình xử lý. Vui lòng thao tác lại"}
				leftButton={{
					onClick: () => {
						setIsShowFailPopUp(false);
					},
					content: "Đóng"
				}}
				rightButton={{
					onClick: () => {
						setIsShowFailPopUp(false);
						handleSubmit();
					},
					content: "Thử lại"
				}}
			>
			</ModalNoti>

  </>
  );
}

export default FormStorage;
